import { GPX_FEATURES } from '@rsos/gainsight';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { useSelectedTextFrom911Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Selectors';
import useHasAccessToUniteEventPane from '../../../hooks/useHasAccessToUniteEventPane';
import { ChatType } from './ChatContext';
import { trackTogglingRCSChatBox } from './rcsTrackings';
import { trackTogglingTF911ChatBox } from './textFrom911Trackings';

export const trackTogglingChatBox = ({
  isExpanded,
  conversationId,
  sessionId,
  chatType,
  tf911Outbound,
  isUniteEventPaneEnabled,
}: {
  isExpanded: boolean;
  conversationId: string;
  sessionId: string;
  chatType: ChatType;
  tf911Outbound: boolean;
  isUniteEventPaneEnabled: boolean;
}) => {
  if (chatType == 'rcs') {
    return trackTogglingRCSChatBox({
      isExpanded,
      conversationId,
      sessionId,
    });
  }

  if (chatType === 'textFrom911') {
    return trackTogglingTF911ChatBox({
      isExpanded,
      conversationId,
      fromOverviewTab: false,
      isUniteEventPaneEnabled,
      feature: tf911Outbound ? GPX_FEATURES.TF911_OUTBOUND : GPX_FEATURES.TF911,
    });
  }
};

export const useTrackTogglingChatBox = () => {
  // TF911 tracking wants a bunch of other data that can only easily be
  // collected via hooks, so we gather that here. If the chat's not tf911, this
  // is all moot.
  const selectedCallerID = useSelectedCallerID();
  const conversation = useSelectedTextFrom911Conversation(
    selectedCallerID || '',
  );
  const tf911Outbound = conversation?.data?.isOutboundSMS;
  const isUniteEventPaneEnabled = useHasAccessToUniteEventPane();
  return (data: {
    isExpanded: boolean;
    conversationId: string;
    sessionId: string;
    chatType: ChatType;
  }) => {
    trackTogglingChatBox({
      ...data,
      tf911Outbound,
      isUniteEventPaneEnabled,
    });
  };
};
